import { render } from "./AppFooter.vue?vue&type=template&id=257ed574"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"
script.render = render

export default script